module.exports = __webpack_public_path__ + "static/img/banner-csr-15.4e9b786.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner-csr-15.jpg
// module id = k4i2
// module chunks = 99